import { ApiError } from '../../api/client';

/**
 * Maps API error status codes to user-friendly error messages.
 * Per the rules:
 * - 400 -> "Some details are invalid. Please check and try again."
 * - 401 -> "Your session has expired. Please sign in again."
 * - 403 -> "You do not have permission to perform this action."
 * - 404 -> "The requested resource was not found."
 * - 409 -> "This resource already exists (e.g. email already in use)."
 */
export function getUserFriendlyErrorMessage(err: unknown, fallbackMessage?: string): string {
  if (err instanceof ApiError) {
    switch (err.status) {
      case 400:
        return 'Some details are invalid. Please check and try again.';
      case 401:
        return 'Your session has expired. Please sign in again.';
      case 403:
        return 'You do not have permission to perform this action.';
      case 404:
        return 'The requested resource was not found.';
      case 409:
        return 'This resource already exists.';
      default:
        return err.message || fallbackMessage || 'An unexpected error occurred. Please try again.';
    }
  }

  if (err instanceof Error) {
    return err.message || fallbackMessage || 'An unexpected error occurred. Please try again.';
  }

  return fallbackMessage || 'An unexpected error occurred. Please try again.';
}

/**
 * Logs errors in development only.
 * Per the rules: "Use `console` logging only for development."
 */
export function logErrorInDev(context: string, err: unknown): void {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error(context, err);
  }
}
